









































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class JxglLeftNav extends Vue {
  @Prop()
  private cState: any;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 跳转习题库列表
   */
  private jumpXtk() {
    localStorage.setItem(
      "xtkListFilters",
      JSON.stringify({
        cate_id: "",
        题目难度: "",
        search: "",
        current_page: 1,
        page_count: 10,
        order_value: 0,
      })
    );
    this.$router.push("/main/jxgl/xtk-list");
  }
  /**
   * @description 跳转试卷库列表
   */
  private jumpSjk() {
    localStorage.setItem(
      "sjkListFilters",
      JSON.stringify({
        试卷名称: "",
        current_page: 1,
        total_page: 0,
        total_count: 0,
      })
    );
    this.$router.push("/main/jxgl/sjk-list");
  }
  /**
   * @description 跳转考试管理列表
   */
  private jumpKsgl() {
    localStorage.setItem(
      "ksglListFilters",
      JSON.stringify({
        考试状态: "",
        class_id: "",
        考试名称: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
        order_value: 0,
      })
    );
    this.$router.push("/main/jxgl/ksgl-list");
  }
  /**
   * @description 跳转班级管理列表
   */
  private jumpBjgl() {
    localStorage.setItem(
      "bjglListFilters",
      JSON.stringify({
        class_id: "",
        姓名: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
      })
    );
    this.$router.push("/main/jxgl/bjgl-list");
  }
}
